import * as Yup from "yup";

// Validation schema for adding or editing an Organization
export const OrganizationValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Organization name is too short")
    .required("Organization name is required"),
  default_currency: Yup.string().required("currency is required"),
  address: Yup.string().required("Address is required"),
  phone_number: Yup.string().required("Phone number is required"),
  business_email: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  timezone: Yup.string(),
  date_format: Yup.string(),
  time_format: Yup.string(),
  number_format: Yup.string(),
  fiscal_year_start: Yup.string(),
  tax_id: Yup.string(),
  website: Yup.string(),
  // .url("Invalid website address")
  // .matches(/^(http|https):\/\/|^www\./, "Website must start with http, https, or www"),
});
